"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributionEventCountsQuerySchema = exports.AttributionEventSummaryQuerySchema = exports.AttributionEventGroupingQuerySchema = exports.AttributionEventGroupingResponseSchema = exports.AttributionEventGroupingSchema = exports.AttributionEventSummaryResponseSchema = exports.AttributionEventValuesSchema = exports.AttributionEventGroupBySchema = exports.AttributionEventsFilterFields = exports.AttributionEventTimestampKeySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.AttributionEventTimestampKeySchema = (0, core_1.StringUnion)([
    "period",
    "installedAtPeriod",
    "clickedAtPeriod",
]);
exports.AttributionEventsFilterFields = {
    campaignId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
    country: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.CountrySchema)),
    token: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AttributionEventTokenSchema)),
    name: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AttributionEventNameSchema)),
    keyword: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AttributionEventKeywordSchema)),
    timestampKey: typebox_1.Type.Optional(exports.AttributionEventTimestampKeySchema),
    ...core_1.DateFilterFields,
};
exports.AttributionEventGroupBySchema = (0, core_1.StringUnion)([
    "keyword",
    "token",
    "country",
    "campaignId",
    "period",
    "name",
]);
exports.AttributionEventValuesSchema = (0, core_1.StrictObject)({
    revenue: core_1.MoneySchema,
    unique: typebox_1.Type.Number(),
});
exports.AttributionEventSummaryResponseSchema = (0, core_1.StrictObject)({
    totals: exports.AttributionEventValuesSchema,
    count: core_1.CountSchema,
});
exports.AttributionEventGroupingSchema = (0, core_1.StrictObject)({
    key: typebox_1.Type.String(),
    value: exports.AttributionEventValuesSchema,
    count: core_1.CountSchema,
});
exports.AttributionEventGroupingResponseSchema = (0, core_1.StrictObject)({
    groups: typebox_1.Type.Array(exports.AttributionEventGroupingSchema),
});
exports.AttributionEventGroupingQuerySchema = (0, core_1.StrictObject)({
    ...exports.AttributionEventsFilterFields,
    by: exports.AttributionEventGroupBySchema,
});
exports.AttributionEventSummaryQuerySchema = (0, core_1.StrictObject)({
    ...exports.AttributionEventsFilterFields,
});
exports.AttributionEventCountsQuerySchema = (0, core_1.StrictObject)({
    ...exports.AttributionEventsFilterFields,
});
